import { useActiveUserContext } from 'contexts/ActiveUserContext'
import { hasPermission } from 'utils/authService';
import _ from 'lodash';
import React from 'react';
import { Tooltip } from 'antd-v5';
import classNames from 'classnames';

export default function AuthorisedContainer({ permission, children, tooltip = "", placement = "top", noAccessText="No access", disabledClassName = "disabled", partialPermissionCheck = false}) {
    useActiveUserContext();
    
    if(!_.isUndefined(permission) && !hasPermission(permission, partialPermissionCheck)){
        return (
                React.Children.count(children) === 1
                ?
                <Tooltip title={noAccessText}>
                    {
                        React.cloneElement(children, {
                            disabled: true,
                            ...(_.has(children.props, 'onClick') ? { onClick: _.noop } : {}),
                            ...(_.has(children.props, 'href') ? { href: undefined } : {}),
                            className: classNames(disabledClassName, children.props.className),
                        })
                    }
                </Tooltip>
                :
                React.Children.map(children, (child, i) => {
                    if (!child) {
                        return null;
                    }
                    return (
                        <Tooltip title={noAccessText}>
                        {
                            React.cloneElement(child, {
                                disabled: true,
                                ...(_.has(child.props, 'onClick') ? { onClick: _.noop } : {}),
                                ...(_.has(child.props, 'href') ? { href: undefined } : {}),
                                className: classNames(disabledClassName, child.props?.className),
                                key: child.props?.key || i
                            })
                        }
                        </Tooltip>
                    );
                })
        );
    }
    return tooltip ? <Tooltip title={tooltip} placement={placement? placement : "top"}>{children}</Tooltip> : children;
}
